import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReviewDetailsComponent } from '../review-details/review-details.component';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'app-create-player',
  templateUrl: './create-player.component.html',
  styleUrls: ['./create-player.component.scss']
})
export class CreatePlayerComponent implements OnInit {

  form: FormGroup;

  type!: any;

  constructor(
    private fb: FormBuilder,
    private modalService: ModalService
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      username: ['', Validators.required],
      playerName: ['', Validators.required]
    });
  }

  // createNewPlayer(){
  //   const payload = {
  //     username: this.username?.value,
  //     playerName: this.playerName?.value,
  //   }
  // }

  confirm() {
    const payload = {
      username: this.username?.value,
      playerName: this.playerName?.value,
    };

    console.log({payload})

    this.modalService.openReviewDetails(payload, 'create-player', {});
    // if (this.form.valid) {
    //   const modalRef = this.modalService.open(ReviewDetailsComponent, { centered: true });
    //   modalRef.componentInstance.reviewData = this.form.value; 
    //   this.close()
    //   modalRef.result.then((result) => {
    //     if (result === 'submit') {
    //       this.createNewPlayer();
    //     }
    //   });
    // } 
  }

  createNewPlayer() {
    const payload = {
      username: this.username?.value,
      playerName: this.playerName?.value,
    };

    console.log(payload)
  }

  get username(){
    return this.form.get('username');
  }

  get playerName(){
    return this.form.get('playerName');
  }

  close(){
    this.modalService.hideCreatePlayer();
  }
}
